import { QueryClient } from '@tanstack/vue-query'

export const createQueryClient = () => {
    return new QueryClient({
        defaultOptions: {
            queries: {
                shallow: true,
            },
        },
    })
}
